import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  createPanchang,
  getPanchang,
  getPanchangDays,
  updatePanchang,
} from "./api";

const initialState = {
  panchangData: [],
  daysData: [],
  fetchLoading: false,
  loading: false,
  error: null,
};

export const createPanchangAsync = createAsyncThunk(
  "panchang/createPanchang",
  async ({ createPanchangValues }, thunkAPI) => {
    try {
      const data = await createPanchang(createPanchangValues);
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to created panchang",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const getPanchangAsync = createAsyncThunk(
  "panchang/getPanchang",
  async (_, thunkAPI) => {
    try {
      const data = await getPanchang();
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to fetch panchang",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const getPanchangDaysAsync = createAsyncThunk(
  "panchang/getPanchangDays",
  async ({ dayId }, thunkAPI) => {
    try {
      const data = await getPanchangDays(dayId);
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to fetch panchang days",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const updatePanchangAsync = createAsyncThunk(
  "panchang/updatePanchang",
  async ({ updatePanchangValues }, thunkAPI) => {
    try {
      const data = await updatePanchang(updatePanchangValues);
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to update panchang",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

const panchangSlice = createSlice({
  name: "panchang",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createPanchangAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPanchangAsync.fulfilled, (state, action) => {
        state.loading = false;
        // toast.success("Login successful!");
      })
      .addCase(createPanchangAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to created panchang";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(getPanchangAsync.pending, (state) => {
        state.fetchLoading = true;
        state.error = null;
      })
      .addCase(getPanchangAsync.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.panchangData = action.payload.data.results;
      })
      .addCase(getPanchangAsync.rejected, (state, action) => {
        state.fetchLoading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to Fetch panchang";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(getPanchangDaysAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPanchangDaysAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.daysData = action.payload.data.results;
      })
      .addCase(getPanchangDaysAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to Fetch panchang days data";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(updatePanchangAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePanchangAsync.fulfilled, (state, action) => {
        state.loading = false;
        // toast.success("Login successful!");
      })
      .addCase(updatePanchangAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to update panchang";
        state.error = errorMessage;
        toast.error(errorMessage);
      });
  },
});

// export const { logout } = panchangSlice.actions;

export default panchangSlice.reducer;
